// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-primary-Clr: #f25d2c;
  --bg-primary-clr: #1e4f6c;
  --text-primary-clr: #1e4f6c;
  --text-secondary-clr: #f25d2c;
  --text-black-Clr: #050505;
  --btn-primary-clr: #f25d2c;
  --primary-hover: #ff774a;
  --btn-secondary-clr: #1e4f6c;
  --btn-secondary-HOVER: #317ba5;
  --paragraph-font-size: 15px;
  --heading1-size: 4rem;
  --heading2-size: 3rem;
}

/* .LoginForm-item p,h1, h2, h3, h4, h5, h6{
    color: black;
} */

.login-wrapper {
  width: 100%;
  height: 100vh;
}
.login-img img {
  width: 100%;
}
.login-img {
  width: 40%;
}
.login-page {
  width: 60%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-49%, -49%);
  padding: 50px 0;
  display: flex;
  border: 1px solid rgb(214, 214, 214);
  border-radius: 10px;
  justify-content: space-evenly;
  align-items: center;
  box-shadow: 0px 0px 4px -9px rgba(0, 0, 0, 0.045),
    0px 0px 11.1px -9px rgba(0, 0, 0, 0.065),
    0px 0px 26.8px -9px rgba(0, 0, 0, 0.085),
    0px 0px 89px -9px rgba(0, 0, 0, 0.13);
}
.LoginForm-item {
  width: 45%;
  gap: 10px;
  padding: 10px;
  display: flex;
}

.email,
.password,
.LoginForm-item {
  display: flex;
  flex-direction: column;
}
.LoginForm-item input {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  border-radius: 5px;
  border: 1px solid #dbdbdb;
  /* border: none; */
  outline: none;
}

/* .LoginForm-item input:focus {
    border: 2px solid rgb(223, 223, 223);
  } */
.login-button button {
  width: 100%;
  height: 40px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  background-color: var(--btn-primary-clr);
  color: white;
  border: none;
  cursor: pointer;
}
.login-button button:hover {
  background-color: var(--primary-hover);
}
.LoginForm-item label,
.dont-account p {
  font-size: 14px;
  font-weight: 500;
  color: #313131;
}
.form-control {
  margin-top: 20px;
}

.dont-account {
  display: flex;
flex-direction: column;
align-items: center;
  justify-content: center;
  gap: 5px;
}

.dont-account a {
  font-size: 14px;
  border: none;
  background: none;
  cursor: pointer;
  text-decoration: underline;
  color: var(--btn-primary-clr);
}

.dont-account a:hover {
  color: var(--primary-hover);
}
.form-title {
  font-size: 40px;
  font-weight: 600;
  text-align: center;
  color: var(--btn-primary-clr);
}
.log-logo img {
  width: 50%;
}
.log-logo {
  justify-content: center;
  display: flex;
}



/* Responsive For Tablet Screen size 767px to 1023px START */
@media (max-width:1023px) {
.login-page{
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
padding-top: 100px;

}
.login-img {
  width: 50%;
}

.LoginForm-item {
  width: 85%;
  gap: 10px;
  padding: 10px;
  display: flex;
}
  }
  
  /* Responsive For Tablet Screen size 601px to 1023px END */
  
  
  
  
  
  /* Responsive For Mobile Screen size 1024px to 1920px START */
  @media (max-width:767px) {
  
    


  }
  
  /* Responsive For Mobile Screen size 1024px to 1920px END */
  `, "",{"version":3,"sources":["webpack://./src/Components/Login_Signup/LoginformStyles.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB;;;yCAGuC;AACzC;AACA;EACE,UAAU;EACV,SAAS;EACT,aAAa;EACb,aAAa;AACf;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;KAEK;AACL;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,sCAAsC;AACxC;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf,sBAAsB;AACtB,mBAAmB;EACjB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,aAAa;AACf;;;;AAIA,4DAA4D;AAC5D;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd,kBAAkB;;AAElB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,SAAS;EACT,aAAa;EACb,aAAa;AACf;EACE;;EAEA,0DAA0D;;;;;;EAM1D,6DAA6D;EAC7D;;;;;EAKA;;EAEA,2DAA2D","sourcesContent":[":root {\n  --bg-primary-Clr: #f25d2c;\n  --bg-primary-clr: #1e4f6c;\n  --text-primary-clr: #1e4f6c;\n  --text-secondary-clr: #f25d2c;\n  --text-black-Clr: #050505;\n  --btn-primary-clr: #f25d2c;\n  --primary-hover: #ff774a;\n  --btn-secondary-clr: #1e4f6c;\n  --btn-secondary-HOVER: #317ba5;\n  --paragraph-font-size: 15px;\n  --heading1-size: 4rem;\n  --heading2-size: 3rem;\n}\n\n/* .LoginForm-item p,h1, h2, h3, h4, h5, h6{\n    color: black;\n} */\n\n.login-wrapper {\n  width: 100%;\n  height: 100vh;\n}\n.login-img img {\n  width: 100%;\n}\n.login-img {\n  width: 40%;\n}\n.login-page {\n  width: 60%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-49%, -49%);\n  padding: 50px 0;\n  display: flex;\n  border: 1px solid rgb(214, 214, 214);\n  border-radius: 10px;\n  justify-content: space-evenly;\n  align-items: center;\n  box-shadow: 0px 0px 4px -9px rgba(0, 0, 0, 0.045),\n    0px 0px 11.1px -9px rgba(0, 0, 0, 0.065),\n    0px 0px 26.8px -9px rgba(0, 0, 0, 0.085),\n    0px 0px 89px -9px rgba(0, 0, 0, 0.13);\n}\n.LoginForm-item {\n  width: 45%;\n  gap: 10px;\n  padding: 10px;\n  display: flex;\n}\n\n.email,\n.password,\n.LoginForm-item {\n  display: flex;\n  flex-direction: column;\n}\n.LoginForm-item input {\n  width: 100%;\n  height: 50px;\n  padding: 0 15px;\n  border-radius: 5px;\n  border: 1px solid #dbdbdb;\n  /* border: none; */\n  outline: none;\n}\n\n/* .LoginForm-item input:focus {\n    border: 2px solid rgb(223, 223, 223);\n  } */\n.login-button button {\n  width: 100%;\n  height: 40px;\n  font-size: 16px;\n  font-weight: 500;\n  border-radius: 4px;\n  background-color: var(--btn-primary-clr);\n  color: white;\n  border: none;\n  cursor: pointer;\n}\n.login-button button:hover {\n  background-color: var(--primary-hover);\n}\n.LoginForm-item label,\n.dont-account p {\n  font-size: 14px;\n  font-weight: 500;\n  color: #313131;\n}\n.form-control {\n  margin-top: 20px;\n}\n\n.dont-account {\n  display: flex;\nflex-direction: column;\nalign-items: center;\n  justify-content: center;\n  gap: 5px;\n}\n\n.dont-account a {\n  font-size: 14px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  text-decoration: underline;\n  color: var(--btn-primary-clr);\n}\n\n.dont-account a:hover {\n  color: var(--primary-hover);\n}\n.form-title {\n  font-size: 40px;\n  font-weight: 600;\n  text-align: center;\n  color: var(--btn-primary-clr);\n}\n.log-logo img {\n  width: 50%;\n}\n.log-logo {\n  justify-content: center;\n  display: flex;\n}\n\n\n\n/* Responsive For Tablet Screen size 767px to 1023px START */\n@media (max-width:1023px) {\n.login-page{\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: auto;\npadding-top: 100px;\n\n}\n.login-img {\n  width: 50%;\n}\n\n.LoginForm-item {\n  width: 85%;\n  gap: 10px;\n  padding: 10px;\n  display: flex;\n}\n  }\n  \n  /* Responsive For Tablet Screen size 601px to 1023px END */\n  \n  \n  \n  \n  \n  /* Responsive For Mobile Screen size 1024px to 1920px START */\n  @media (max-width:767px) {\n  \n    \n\n\n  }\n  \n  /* Responsive For Mobile Screen size 1024px to 1920px END */\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
